import { AutogenLayoutPaymentMethodDetail } from "./autogen/AutogenLayoutPaymentMethodDetail";

export class PaymentMethodDetail extends AutogenLayoutPaymentMethodDetail {

}